import React, {
  Children,
  useLayoutEffect,
  useEffect,
  cloneElement,
  createRef,
} from "react";
import { forwardRef, useRef } from "react";
import Phaser from "phaser";
import usePhaser from "../hooks/usePhaser";
import GameObject from "./GameObject";

const Container = forwardRef(
  (
    { args = [0, 0], addedToScene = () => {}, children, ...props },
    externalRef
  ) => {
    const localRef = useRef();
    const ref = externalRef || localRef;

    const onObjectAddedToScene = (obj) => {
      ref.current.add(obj);
    };
    const extractPhaserChildren = (_children) => {
      return Children.toArray(_children).map((ch) => {
        if (String(ch.type).includes("react.fragment")) {
          return cloneElement(ch, {
            children: extractPhaserChildren(ch.props.children),
          });
        }
        return cloneElement(ch, {
          addedToSceneForParent: onObjectAddedToScene,
        });
      })
    };
    // console.log(Children.toArray(children));
    return (
      <GameObject ref={ref} type="Container" args={args} {...props}>
        {/* Inject dataParentRef to children */}
        {extractPhaserChildren(children)}
      </GameObject>
    );
  }
);

Container.displayName = "Container";
export default Container;
